import {Component, computed, contentChild, Directive, input, TemplateRef} from '@angular/core';
import {LotteryListItemEmptyComponent} from "../lottery-list-item-empty/lottery-list-item-empty.component";
import {NgTemplateOutlet, SlicePipe} from "@angular/common";
import {LotteryListItemSkeletonComponent} from "../lottery-list-item-skeleton/lottery-list-item-skeleton.component";
import {Lottery} from "../../model/lottery";
import {DetailsButtonComponent} from "../details-button/details-button.component";

interface LotteryListItemContext<T extends Lottery> {
  $implicit: T;
}

@Directive({
  selector: 'ng-template[lotteryListItem]',
  standalone: true,
})
export class LotteryListItemDirective<T extends Lottery> {
  lotteryListItem = input.required<T[] | undefined>();

  static ngTemplateContextGuard<TContext extends Lottery>(
    dir: LotteryListItemDirective<TContext>,
    ctx: unknown
  ): ctx is LotteryListItemContext<TContext> {
    return true;
  }
}

// @Directive({
//   selector: 'ng-template[lotteryListItemWithApplicationInfo]',
//   standalone: true,
// })
// export class LotteryListItemWithApplicationInfoDirective extends LotteryListItemDirective {
//   static override ngTemplateContextGuard(
//     dir: LotteryListItemDirective,
//     ctx: unknown
//   ): ctx is LotteryListItemContext<ApartmentWithApplicationInfo> {
//     return true;
//   }
// }

@Component({
  selector: 'homey-lottery-list',
  standalone: true,
  imports: [
    LotteryListItemEmptyComponent,
    DetailsButtonComponent,
    SlicePipe,
    NgTemplateOutlet,
    LotteryListItemSkeletonComponent
  ],
  templateUrl: './lottery-list.component.html',
})
export class LotteryListComponent<T extends Lottery> {
  public readonly emptyState = input<{
    title: string,
    description: string,
  }>();

  public readonly lastLineItem = contentChild.required(LotteryListItemDirective<T>, {read: TemplateRef});
  public readonly lotteries = input.required<T[] | null | undefined>()
  public readonly limit = input<{
    number: number,
    seeMoreLink?: string[],
    seeMoreText?: string | undefined,
  }>()
  protected readonly limitCount = computed(
    () => {
      const limit = this.limit();
      return limit ? limit.number : this.lotteries()?.length ?? 0;
    }
  )
  protected readonly skeletons = computed(
    () => {
      const limit = this.limit();

      if (!limit) {
        return [];
      }

      const count = limit.number > 6 ? 6 : limit.number;

      return Array.from({length: count}, (_, index) => index);
    }
  )
}
